import React from "react";
import cn from "classnames";
import { MapHomeIcon } from "@/icons";
import MobileList from "./mobileList";

/**
 * 移动端地图工具栏组件
 * 包含空状态提示、回到首页按钮和餐厅列表
 */
const MapViewMobileTool = ({
  loading,
  showEmpty,
  handleCleanFilter,
  showHomeIcon,
  handleMapHomeClick,
  mobileListRef,
  swiperKey,
  mapSelectedRestaurants,
  avgPriceLabel,
  handleSlideTo,
}) => {
  return (
    <>
      {/* 空状态提示 */}
      {showEmpty.visible && (
        <div
          className={cn("map-view-empty", {
            "map-view-empty-by-map": true,
          })}
          onClick={handleCleanFilter}
        >
          {showEmpty.text}
        </div>
      )}
      {/* 加载状态 */}
      {loading && (
        <div className="map-view-loading">
          <div className="map-view-loading-mask"></div>
          <div className="map-view-loading-spinner"></div>
        </div>
      )}
      <div className="map-view-mobile-overlay">
        {showHomeIcon && (
          <div className="map-view-mobile-overlay-back">
            <div className="overlay-back-icon" onClick={handleMapHomeClick}>
              <MapHomeIcon />
            </div>
          </div>
        )}
        <MobileList
          ref={mobileListRef}
          key={swiperKey}
          restaurants={mapSelectedRestaurants}
          avgPriceLabel={avgPriceLabel}
          onSlideTo={handleSlideTo}
        />
      </div>
    </>
  );
};

export default MapViewMobileTool;
